<template>
  <el-select style="width: 100%" v-model="currentSelected" multiple :placeholder="placeholder" clearable :popper-append-to-body="appendToBody"
    :no-data-text="noDataText" @change="handleChange">
    <el-option v-if="isAll && options && options.length > 0" :value="allOptionValue"
      :label="isCheckAll ? '取消全选' : '全选'">
    </el-option>
    <el-option v-for="item in options" :key="item[valueKey]" :label="item[labelKey]" :value="item[valueKey]">
    </el-option>
  </el-select>
</template>

<script>
export default {

  props: {
    options: {
      type: Array,
      default: () => []
    },
    selectedOptions: {
      type: Array,
      default: () => []
    },
    valueKey: {
      type: String,
      default: 'paramKey'
    },
    labelKey: {
      type: String,
      default: 'paramValue'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    isAll: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
    noDataText: {
      type: String,
      default: '无数据'
    }
  },
  data() {
    return {
      allOptionValue: 'all',
      isCheckAll: false,
    };
  },
  model: {
    prop: 'selectedOptions',
    event: 'update:selectedOptions'
  },
  computed: {
    currentSelected: {
      get() {
        let value = [];
        if (this.selectedOptions instanceof Array) {
          this.selectedOptions.forEach(o => {
            value.push(o);
          });
        }
        this.isCheckAll = this.selectedOptions.length === this.options.length; // eslint-disable-line
        return value;
      },
      set(value) {
        this.$emit('update:selectedOptions', value);
      }
    },
  },
  methods: {
    handleChange(val) {
      if (val.length >= this.options.length && this.isCheckAll) {
        // 点击了取消全选
        this.currentSelected = []
      } else if (val.indexOf('all') != -1 && !this.isCheckAll) {
        // 点击了全选
        this.currentSelected = this.options.map(item => item[this.valueKey]);
      } else {
        // 其他情况
        this.currentSelected = val;
      }
    },
  },
};
</script>